<template>
  <div :class="$style.actionSidebarDesignButtonWrapper">
    <div :class="$style.actionSidebarDesignButtonItem">
      <button
        v-if="src === null"
        :class="$style.actionSidebarDesignButton"
        @click="$emit('click')"
      >
        <AddRounded :class="$style.actionSidebarDesignButtonIcon" />
      </button>
      <img
        v-else
        :class="$style.actionSidebarDesignButtonImage"
        :src="src"
        alt=""
      >
    </div>

    <span :class="$style.actionSidebarDesignButtonPlaceholder">
      {{ placeholder }}
    </span>

    <button
      v-if="src"
      :class="$style.actionSidebarDesignButtonRemove"
      @click="$emit('handleRemove')"
    >
      <DeleteOutlineRounded :class="$style.actionSidebarDesignButtonRemoveIcon" />
    </button>
  </div>
</template>

<script>
import AddRounded from '@/assets/icons/AddRounded.svg?inline'
import DeleteOutlineRounded from '@/assets/icons/DeleteOutlineRounded.svg?inline'

export default {
  components: {
    AddRounded,
    DeleteOutlineRounded
  },
  props: {
    placeholder: {
      type: String,
      default: '140x56px, png, jpg'
    },
    src: {
      type: String,
      default: null
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.actionSidebarDesignButtonWrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.actionSidebarDesignButtonItem {
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 2px solid var(--blue-shade-8);
  padding: 2px;
  background-color: var(--white);
  overflow: hidden;
}

.actionSidebarDesignButtonPlaceholder {
  color: var(--grey-400);
  word-wrap: anywhere !important;

  @include mixins.body2;
}

.actionSidebarDesignButton {
  all: unset;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--blue-shade-8);
  color: var(--blue-shade-50);
  border-radius: 2px;
}

.actionSidebarDesignButtonIcon {
  --s: 24px;

  width: var(--s);
  height: var(--s);
}

.actionSidebarDesignButtonImage {
  display: flex;
  border-radius: 2px;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.actionSidebarDesignButtonRemove {
  --s: 24px;

  all: unset;
  position: absolute;
  z-index: 2;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: var(--s);
  height: var(--s);
  color: var(--white);
  background-color: var(--main-red);
  cursor: pointer;
}

.actionSidebarDesignButtonRemoveIcon {
  --s: 16px;

  width: var(--s);
  height: var(--s);
}
</style>
